var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { UploadList } from './UploadList';
import { Dragger } from './Dragger';
import { DivTag, InputTag } from '../../Utils/AtomicTag';
import { request as defaultRequest } from '../../Utils/request';
import { message } from '../Message';
var Upload = /** @class */ (function (_super) {
    __extends(Upload, _super);
    function Upload(props) {
        var _this = _super.call(this, props) || this;
        _this.fileInput = React.createRef();
        _this.updateFileList = function (updateFile, updateObj) {
            var prevList = _this.state.fileList;
            var tempArr = prevList.map(function (file) {
                if (file.uid === updateFile.uid) {
                    return __assign(__assign({}, file), updateObj);
                }
                else {
                    return file;
                }
            });
            _this.setState({
                fileList: tempArr,
            });
        };
        _this.handleClick = function () {
            if (_this.fileInput.current) {
                _this.fileInput.current.click();
            }
        };
        _this.handleRemove = function (file) {
            var _a = _this.props, onRemove = _a.onRemove, onChange = _a.onChange;
            _this.setState({
                fileList: _this.state.fileList.filter(function (item) { return item.uid !== file.uid; }),
            }, function () {
                if (onRemove) {
                    onRemove(file);
                }
                onChange &&
                    onChange({
                        file: file,
                        fileList: _this.state.fileList,
                    });
            });
        };
        _this.handleFileChange = function (e) {
            var files = e.target.files;
            if (!files) {
                return;
            }
            _this.uploadFiles(files);
            if (_this.state.val) {
                _this.setState({
                    val: '',
                });
            }
        };
        _this.uploadFiles = function (files) {
            var postFiles = Array.from(files);
            var onBeforeUpload = _this.props.onBeforeUpload;
            postFiles.forEach(function (file) {
                if (!onBeforeUpload) {
                    _this.post(file);
                }
                else {
                    var result = onBeforeUpload(file);
                    if (result && result instanceof Promise) {
                        result.then(function (processedFile) {
                            _this.post(processedFile);
                        });
                    }
                    else if (result !== false) {
                        _this.post(file);
                    }
                }
            });
        };
        _this.post = function (file) {
            var _a = _this.props, data = _a.data, action = _a.action, headers = _a.headers, withCredentials = _a.withCredentials, onChange = _a.onChange, name = _a.name, method = _a.method, maxsize = _a.maxsize, maximum = _a.maximum, customRequest = _a.customRequest;
            var _file = {
                uid: Math.random() + 'upload-file',
                status: 'ready',
                name: file.name,
                size: file.size,
                percent: 0,
                raw: file,
            };
            // 添加上传文件最大尺寸
            var computedMaxsize = Math.abs(maxsize);
            if (computedMaxsize && Math.round(file.size / 1024) > computedMaxsize) {
                // 大于 computedMaxsize KB
                message.error("\u4E0A\u4F20\u5C3A\u5BF8\u4E0D\u80FD\u8D85\u8FC7 " + computedMaxsize + " KB");
                return false;
            }
            // 添加最大上传数量
            var computedMaximum = ~~Math.abs(maximum);
            if (computedMaximum) {
                // 当为 1 时，始终用最新上传的代替当前
                if (computedMaximum === 1) {
                    _this.setState({
                        fileList: [],
                    });
                }
                else {
                    if (_this.state.fileList.length === computedMaximum) {
                        message.error("\u4E0A\u4F20\u6570\u91CF\u4E0D\u80FD\u8D85\u8FC7 " + computedMaximum);
                        return false;
                    }
                }
            }
            _this.setState(function (prevState) { return ({
                fileList: __spread(prevState.fileList, [_file]),
            }); });
            var request = customRequest || defaultRequest;
            request({
                headers: headers,
                withCredentials: withCredentials,
                file: file,
                data: data,
                filename: name,
                action: action,
                onProgress: function (e) {
                    var fileList = _this.state.fileList;
                    var percentage = Math.round((e.loaded * 100) / e.total) || 0;
                    if (percentage < 100) {
                        _this.updateFileList(_file, { percent: percentage, status: 'uploading' });
                        if (onChange) {
                            _file.status = 'uploading';
                            onChange({
                                file: _file,
                                fileList: fileList,
                                resp: percentage,
                            });
                        }
                    }
                },
                onSuccess: function (res) {
                    var fileList = _this.state.fileList;
                    _this.updateFileList(_file, { status: 'success', response: res });
                    if (onChange) {
                        _file.status = 'success';
                        onChange({
                            file: _file,
                            fileList: fileList,
                            res: res,
                        });
                    }
                },
                onError: function (err, response) {
                    var fileList = _this.state.fileList;
                    _this.updateFileList(_file, { status: 'error', error: err });
                    if (onChange) {
                        _file.status = 'error';
                        onChange({
                            file: _file,
                            fileList: fileList,
                            resp: err,
                        });
                    }
                },
            });
        };
        _this.handleDrop = function (e) {
            e.preventDefault();
            _this.setState({
                dragOver: false,
            });
            _this.uploadFiles(e.dataTransfer.files);
        };
        _this.handleDrag = function (e, over) {
            e.preventDefault();
            _this.setState({
                dragOver: over,
            });
        };
        _this.state = {
            val: '',
            fileList: props.defaultFileList || [],
            dragOver: false,
        };
        return _this;
    }
    Upload.prototype.render = function () {
        var _this = this;
        var _a = this.props, accept = _a.accept, multiple = _a.multiple, children = _a.children, className = _a.className, style = _a.style, listType = _a.listType, type = _a.type, previewFile = _a.previewFile, disabled = _a.disabled;
        var _b = this.state, fileList = _b.fileList, val = _b.val, dragOver = _b.dragOver;
        var draggerBox = [
            'relative',
            'inline-block',
            'w-px-480',
            'h-px-238',
            'border',
            'border-dashed',
            dragOver ? 'border-brand-600' : 'border-gray-300',
            'rounded-md',
            'box-border',
            'hover:border-brand-600',
            'cursor-pointer',
            dragOver ? 'bg-brand-10' : 'bg-gray-100',
            'text-center',
            'pt-px-64',
        ];
        var pictureCard = [
            'relative',
            'inline-block',
            'w-px-108',
            'h-px-108',
            'pt-px-16',
            'text-sm',
            'text-center',
            'border',
            'border-dashed',
            'border-gray-300',
            'rounded-md',
            'bg-gray-100',
            'cursor-pointer',
            'hover:border-brand-600',
        ];
        if (type === 'drag') {
            return (React.createElement(DivTag, { name: Upload.NAME, className: className, style: style },
                React.createElement(DivTag, { atomics: draggerBox, onClick: this.handleClick, onDragOver: function (e) {
                        _this.handleDrag(e, true);
                    }, onDragLeave: function (e) {
                        _this.handleDrag(e, false);
                    }, onDrop: this.handleDrop },
                    children,
                    React.createElement(InputTag, { atomics: "hidden", ref: this.fileInput, id: "file", onChange: this.handleFileChange, type: "file", value: val, disabled: disabled, accept: accept, multiple: multiple })),
                fileList.length > 0 && React.createElement(UploadList, { fileList: fileList, onRemove: this.handleRemove })));
        }
        if (listType === 'picture-card') {
            return (React.createElement(DivTag, { name: Upload.NAME, className: className, style: style },
                React.createElement(DivTag, { atomics: pictureCard, onClick: this.handleClick },
                    children,
                    React.createElement(InputTag, { atomics: "hidden", ref: this.fileInput, value: val, onChange: this.handleFileChange, type: "file", disabled: disabled, accept: accept, multiple: multiple })),
                fileList.length > 0 && (React.createElement(UploadList, { fileList: fileList, previewFile: previewFile, listType: listType, onRemove: this.handleRemove }))));
        }
        return (React.createElement(DivTag, { name: Upload.NAME, className: className, style: style },
            React.createElement(DivTag, { atomics: "inline-block", onClick: this.handleClick },
                children,
                React.createElement(InputTag, { atomics: "hidden", ref: this.fileInput, value: val, onChange: this.handleFileChange, type: "file", disabled: disabled, accept: accept, multiple: multiple })),
            fileList.length > 0 && React.createElement(UploadList, { fileList: fileList, onRemove: this.handleRemove })));
    };
    Upload.defaultProps = defaultProps;
    Upload.NAME = 'upload';
    Upload.displayName = 'Upload';
    Upload.Dragger = Dragger;
    Upload.tempArr1 = [];
    return Upload;
}(PureComponent));
export { Upload };
